import { ReactNode } from 'react'
import styles from './ChatMessages.module.css'

interface ChatMessagesProps {
  children: ReactNode
}

export function ChatMessages({ children }: ChatMessagesProps) {
  return <div className={styles.messages}>{children}</div>
}
